import axios from "axios";
import { toast } from "react-toastify";

export const handleApiCall = async (method = "", url = "", data = {}, token = "") => {
  let axiosConfig = {
    method,
    url: `${process.env.REACT_APP_API}${url}`,
    headers: {
      Authorization: `Bearer ${localStorage?.getItem("sessionToken") || token}`,
    },
  };

  // For FormData, let axios automatically set Content-Type with boundary
  // Don't set Content-Type explicitly for FormData
  if (method !== "get") {
    axiosConfig["data"] = data;
    // If data is FormData, axios will automatically set Content-Type to multipart/form-data
    // We don't need to set it explicitly
  }

  try {
    let response = await axios(axiosConfig);
    return response;
  } catch (error) {
    console.warn(error);

    // Get error message from backend
    const errorMsg = error?.response?.data?.errorMessage || error?.response?.data?.message || "Something went wrong!";
    const statusCode = error?.response?.status;

    // Handle 401 - Unauthorized (but not for login page)
    if (statusCode === 401) {
      // Check if it's a login-related error (Invalid credentials)
      if (errorMsg === "Invalid credentials") {
        toast.error(errorMsg);
        return { error: true, message: errorMsg };
      }
      // For other 401 errors (session expired)
      toast.error("Session expired. Please log in again.");
      setTimeout(() => {
        localStorage.removeItem("sessionToken");
        window.location.href = "/";
      }, 2000);
      return { error: true, message: "Session expired" };
    }

    // Handle 404 - Token Invalid (only for specific token invalid message)
    if (statusCode === 404 && errorMsg === "Your token is invalid!") {
      toast.error("Your session has expired. Please log in again.");
      setTimeout(() => {
        localStorage.removeItem("sessionToken");
        window.location.href = "/";
      }, 2000);
      return { error: true, message: "Token invalid" };
    }

    // Handle 404 - Admin not found (login error)
    if (statusCode === 404 && errorMsg === "Admin not found") {
      toast.error(errorMsg);
      return { error: true, message: errorMsg };
    }

    // Handle 404 - Something went wrong (logout user)
    if (statusCode === 404 && errorMsg === "Something went wrong") {
      toast.error("Your session has expired. Please log in again.");
      setTimeout(() => {
        localStorage.removeItem("sessionToken");
        window.location.href = "/";
      }, 2000);
      return { error: true, message: "Session expired" };
    }

    // Handle all other errors - show the actual error message from backend
    toast.error(errorMsg);
    console.log(errorMsg);
    return { error: true, message: errorMsg };
  }
};
